<div class="background" #spinnerContainer>
    <mat-progress-spinner
        [class]="color"
        [color]="color"
        mode="determinate"
        [strokeWidth]="spinnerStrokeWidth"
        [value]="remainingPercentage || 100"
        [diameter]="spinnerDiameter"
    >
    </mat-progress-spinner>
    <div class="remaining-time">{{ remainingTimeInSeconds }}</div>
</div>
